/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { TableVisualizationWrapper } from './TableVisualizationWrapper';
import datasetTypes from '../../../enums/datasetTypes';
import tableVisualizationStaticPropertiesReducer from './reducers/tableVisualizationStaticPropertiesReducer';

export default {
    legacyAdhoc: 'N/A',
    cssClass: 'Table',
    parentClass: 'Grid',
    bundleName: 'adhoc.visualisation.chooser.type.TABLE',
    name: 'Table',
    group: 'adhoc.visualisation.chooser.type.GROUP_DATA_GRID',
    datasetType: datasetTypes.MULTI_LEVEL,
    controlsDataLoading: true,
    component: TableVisualizationWrapper,
    staticPropertiesReducer: tableVisualizationStaticPropertiesReducer,
    defaultDynamicProperties: {
        rowsCountToRender: 50,
        headerHeight: -1,
        bottomHeight: -1,
        tableContainerHeight: -1,
        contentHeight: -1,
        viewPortHeight: -1,
        minRowHeight: -1,
        offsetTop: -1,
        rowHeights: []
    },
    requirements: {
        measures: {
            min: 0,
            inRow: false
        },
        fields: {
            min: 0
        }
    }
};
